import React from 'react';

import colors from '../sl-colors';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
  variant?: 'solid' | 'outline';
}

export default function MoreVert({
  color = colors.primary['600'],
  variant = 'outline',
  ...props
}: Props) {
  if (variant === 'solid') {
    return (
      <svg
        width={16}
        height={16}
        viewBox="0 0 4 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.66667 3.66732C2.58333 3.66732 3.33333 2.91732 3.33333 2.00065C3.33333 1.08398 2.58333 0.333984 1.66667 0.333984C0.75 0.333984 0 1.08398 0 2.00065C0 2.91732 0.75 3.66732 1.66667 3.66732ZM1.66667 5.33398C0.75 5.33398 0 6.08398 0 7.00065C0 7.91732 0.75 8.66732 1.66667 8.66732C2.58333 8.66732 3.33333 7.91732 3.33333 7.00065C3.33333 6.08398 2.58333 5.33398 1.66667 5.33398ZM0 12.0007C0 11.084 0.75 10.334 1.66667 10.334C2.58333 10.334 3.33333 11.084 3.33333 12.0007C3.33333 12.9173 2.58333 13.6673 1.66667 13.6673C0.75 13.6673 0 12.9173 0 12.0007Z"
          fill={color}
        />
      </svg>
    );
  }
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.16675 3.33333C6.16675 2.32386 6.99061 1.5 8.00008 1.5C9.00956 1.5 9.83341 2.32386 9.83341 3.33333C9.83341 4.34281 9.00956 5.16667 8.00008 5.16667C6.99061 5.16667 6.16675 4.34281 6.16675 3.33333ZM8.00008 2.5C7.54289 2.5 7.16675 2.87614 7.16675 3.33333C7.16675 3.79052 7.54289 4.16667 8.00008 4.16667C8.45727 4.16667 8.83341 3.79052 8.83341 3.33333C8.83341 2.87614 8.45727 2.5 8.00008 2.5ZM6.16675 8C6.16675 6.99052 6.99061 6.16667 8.00008 6.16667C9.00956 6.16667 9.83341 6.99052 9.83341 8C9.83341 9.00948 9.00956 9.83333 8.00008 9.83333C6.99061 9.83333 6.16675 9.00948 6.16675 8ZM8.00008 7.16667C7.54289 7.16667 7.16675 7.54281 7.16675 8C7.16675 8.45719 7.54289 8.83333 8.00008 8.83333C8.45727 8.83333 8.83341 8.45719 8.83341 8C8.83341 7.54281 8.45727 7.16667 8.00008 7.16667ZM6.16675 12.6667C6.16675 11.6572 6.99061 10.8333 8.00008 10.8333C9.00956 10.8333 9.83341 11.6572 9.83341 12.6667C9.83341 13.6761 9.00956 14.5 8.00008 14.5C6.99061 14.5 6.16675 13.6761 6.16675 12.6667ZM8.00008 11.8333C7.54289 11.8333 7.16675 12.2095 7.16675 12.6667C7.16675 13.1239 7.54289 13.5 8.00008 13.5C8.45727 13.5 8.83341 13.1239 8.83341 12.6667C8.83341 12.2095 8.45727 11.8333 8.00008 11.8333Z"
        fill={color}
      />
    </svg>
  );
}
